export default __webpack_public_path__ + "static/media/casalChavePix.1afcfe01.png";